import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'findInArray',
})
export class FindInArrayPipe implements PipeTransform {

    public transform(value: string | string[], array: string[]): boolean {
        if (value == null || array == null) {
            return true;
        }

        if (typeof value === 'string') {
            const result: string = array.find((item: string) => item === value);
            // eslint-disable-next-line eqeqeq
            return result != undefined;
        } else {
            const result: string = value.find((val: string) => {
                // eslint-disable-next-line eqeqeq
                return array.find((item: string) => item === val) != undefined;
            });
            // eslint-disable-next-line eqeqeq
            return result != undefined;
        }
    }

}
